const DEFAULT_LOCALE = 'en';

export const normalizeTranslationKey = (key) => {
    if (typeof key === 'string') {
        return key.trim();
    }

    if (key === null || typeof key === 'undefined') {
        return '';
    }

    return String(key).trim();
};

export const buildSiteTranslationKey = (key) => {
    const normalizedKey = normalizeTranslationKey(key);

    if (normalizedKey === '') {
        return '';
    }

    return normalizedKey.startsWith('site.')
        ? normalizedKey
        : `site.${normalizedKey}`;
};

export const resolveTranslationLocale = (locale, Lingua, fallbackLocale = DEFAULT_LOCALE) => {
    const normalizedLocale = normalizeTranslationKey(locale);

    if (normalizedLocale !== '') {
        return normalizedLocale;
    }

    if (typeof document !== 'undefined') {
        const documentLocale = normalizeTranslationKey(document.documentElement?.lang);

        if (documentLocale !== '') {
            return documentLocale;
        }
    }

    const availableLocales = Object.keys(Lingua?.translations ?? {}).filter((candidate) => {
        return typeof candidate === 'string' && candidate !== '' && !candidate.endsWith('.zip');
    });

    if (availableLocales.includes(fallbackLocale)) {
        return fallbackLocale;
    }

    return availableLocales[0] ?? fallbackLocale;
};